"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppModule = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const app_controller_1 = require("./app.controller");
const app_service_1 = require("./app.service");
const simple_auth_module_1 = require("./simple-auth/simple-auth.module");
const jwt_1 = require("@nestjs/jwt");
const auth_guard_1 = require("../guards/auth.guard");
const role_guard_1 = require("../guards/role.guard");
const typeorm_config_1 = require("../../../service-lib/src/lib/database/typeorm.config");
const typeorm_1 = require("@nestjs/typeorm");
const access_control_list_module_1 = require("./access-control-list/access-control-list.module");
const user_management_module_1 = require("./user-management/user-management.module");
const service_communication_1 = require("../../../service-lib/src/lib/service-communication");
const environment_1 = require("../../../service-lib/src/lib/environment");
const service_lib_module_1 = require("../../../service-lib/src/lib/service-lib.module");
let AppModule = class AppModule {
    constructor(serviceRegistrationService) {
        this.serviceRegistrationService = serviceRegistrationService;
    }
    async onModuleInit() {
        const serviceInfo = {
            name: "auth-service",
            url: `${environment_1.ENV.URL_AUTH_SERVICE}`,
            port: environment_1.ENV.PORT_AUTH_SERVICE,
            healthCheck: "/health",
            status: "active",
        };
        await this.serviceRegistrationService.registerService(serviceInfo);
    }
};
exports.AppModule = AppModule;
exports.AppModule = AppModule = tslib_1.__decorate([
    (0, common_1.Module)({
        imports: [
            typeorm_1.TypeOrmModule.forRoot(typeorm_config_1.typeOrmConfig),
            simple_auth_module_1.SimpleAuthModule,
            jwt_1.JwtModule.register({
                global: true,
                secret: environment_1.ENV.JWT_SECRET,
                signOptions: { expiresIn: environment_1.ENV.JWT_EXPIRATION },
            }),
            access_control_list_module_1.AccessControlModule,
            user_management_module_1.UserManagementModule,
            service_lib_module_1.InsuranceWellnessHubServiceLibModule,
        ],
        controllers: [app_controller_1.AppController],
        providers: [app_service_1.AppService, service_communication_1.ServiceRegistrationService, auth_guard_1.AuthGuard, role_guard_1.RolesGuard],
        exports: [auth_guard_1.AuthGuard, AppModule, role_guard_1.RolesGuard],
    }),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof service_communication_1.ServiceRegistrationService !== "undefined" && service_communication_1.ServiceRegistrationService) === "function" ? _a : Object])
], AppModule);
